<template>
  <div id="map">
    <nav class="nav-top">
      <div id="nav-links">
        <h1 id="title">Random Road</h1>
        <router-link to="/about">About Us</router-link>
      </div>
    </nav>
    <div class="card" id="map-info">
      <section class="card-header center">
        <p class="card-header-title">
          <router-link to="/gallery/nine_elms">Gallery</router-link>
        </p>
      </section>
      <div class="card-content" id="country">
        <div class="content">
          <span>{{ country }}</span>
        </div>
      </div>
      <section class="card-footer">
        <a href="#" v-on:click="next" class="card-footer-item next">
          <b>Next Location</b>&nbsp;<font-awesome-icon :icon="['fas', 'angle-double-right']" />
        </a>
      </section>
    </div>
    <section>
      <div id="pano-view"></div>
    </section>
    <div id="main_adds"></div>
  </div>
</template>

<script>
import { Random, browserCrypto } from 'random-js'
import postscribe from 'postscribe'
import { Loader } from '@googlemaps/js-api-loader'
import myadds from '../assets/myads.html'

const random = new Random(browserCrypto)
let pointsLength
let currentIndex = 0
let pointIds
const loader = new Loader({
  apiKey: 'AIzaSyCIAjarA_XL2-JfiE9MbDaLZm69s6DCqyA',
  version: 'weekly'
})
const defaultLat = 49.9538862
const defaultLng = 23.2314887
const nextPoint = () => {
  let pointId = pointIds[currentIndex]
  if (currentIndex < pointsLength - 1) {
    currentIndex++
  } else {
    currentIndex = 0
  }
  return pointId
}

export default {
  name: 'Map',
  data () {
    return {
      country: ''
    }
  },
  methods: {
    next: function (event) {
      let randomNum = nextPoint()
      fetch(`https://us-central1-mapview-306310.cloudfunctions.net/getPlace?random=${randomNum}`)
        .then(async response => {
          const data = await response.json()
          if (!response.ok) {
            const error = (data && data.message) || response.statusText
            return Promise.reject(error)
          }
          this.country = data.country
          const position = getData(data)
          // eslint-disable-next-line no-undef,no-new
          new google.maps.StreetViewPanorama(
            document.getElementById('pano-view'),
            { position, pov: { heading: 165, pitch: 0 } }
          )
        })
        .catch(error => {
          this.errorMessage = error
          console.error('There was an error!', error)
        })
    }
  },
  mounted () {
    fetch('https://us-central1-mapview-306310.cloudfunctions.net/getCount')
      .then(async response => {
        const data = await response.json()
        if (!response.ok) {
          const error = (data && data.message) || response.statusText
          return Promise.reject(error)
        }
        pointsLength = +data.max
        pointIds = random.shuffle(Array.from({length: pointsLength}, (_, i) => i + 1))
      })
      .then(() => {
        let randomNum = nextPoint()
        fetch(`https://us-central1-mapview-306310.cloudfunctions.net/getPlace?random=${randomNum}`)
          .then(async response => {
            const data = await response.json()
            if (!response.ok) {
              const error = (data && data.message) || response.statusText
              return Promise.reject(error)
            }
            this.country = data.country
            await loader.load()
            const position = getData(data)
            // eslint-disable-next-line no-undef,no-new
            new google.maps.StreetViewPanorama(
              document.getElementById('pano-view'),
              { position, pov: { heading: 165, pitch: 0 } }
            )
          })
      })
      .catch(error => {
        this.errorMessage = error
        console.error('There was an error!', error)
      })
    // eslint-disable-next-line no-useless-escape
    postscribe('#main_adds', myadds)
  }
}

function getData (data) {
  if (data.lat && data.lng) {
    return { lat: data.lat, lng: data.lng }
  }
  if (data.iframe_src) {
    const res = extractLatLngFromGoogleMapsUrl(data.iframe_src)
    if (!res) {
      return { lat: defaultLat, lng: defaultLng }
    }
    return { lat: Number(res.lat), lng: Number(res.lng) }
  }
  return { lat: defaultLat, lng: defaultLng }
}
function extractLatLngFromGoogleMapsUrl (url) {
  // Patterns to match different possible formats of Google Maps URLs
  const patterns = [
    /!1d([0-9.]+)!2d([0-9.]+)/,
    /@([0-9.-]+),([0-9.-]+)/
  ]

  for (const pattern of patterns) {
    const match = url.match(pattern)
    if (match) {
      const lat = match[1]
      const lng = match[2]
      return { lat, lng }
    }
  }

  return null
}
</script>

<style>
.nav-top {
  width: 100%;
}
#nav-links {
  font-size: 0.5pt;
  position: absolute;
  right: 0;
}
#main_adds {
  height: 100px;
  position: fixed;
  bottom: 0px;
  width: 100%;
}
#title{
  display: inline;
}
.card-header-title{
  margin-left: 28%;
}
#map-info {
  width: 170px;
  position: absolute;
  top: 90px;
  font-size: 0.8em;
  z-index: 2000
}
#country {
  padding: 0.5rem;
}
#country .content{
  text-align: center;
}
.next {}
#pano-view {
  float: left;
  height: 80%;
  width: 100%;
  position: fixed!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Map.vue